import {Card, Container, Group, Menu, rem, Space, Tabs, Text, Title, UnstyledButton} from "@mantine/core";
import {useLocation, useNavigate} from "react-router-dom";
import {PropsWithChildren, useCallback} from "react";
import {RegionEntity} from "@ots-frontend/ots-data";
import {RegionDetails} from "./RegionDetails";
import {createContentStyles} from "../../../theme/useContentStyles";
import {IconChevronDown} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import {RegionAction, RegionActionMenuDropdown} from "../../menu/RegionActionMenu/RegionActionMenu";

const useStyles = createContentStyles((theme) => ({
  mainSection: {
    paddingBottom: theme.spacing.sm
  }
}));

export type RegionProfileProps = PropsWithChildren<{
  region: RegionEntity
}>

const tabs = [
  {
    key: "details",
    value: "Details"
  },
];

export const RegionProfile = (props: RegionProfileProps) => {
  const {region} = props;

  const {classes} = useStyles();

  const navigate = useNavigate();
  const {state} = useLocation();
  const {t} = useTranslation()

  const onActionClick = useCallback((action: RegionAction) => {
    // TODO: implement action clicks
  }, [region, navigate])

  const items = tabs.map((tab) => (
    <Tabs.Tab value={tab.key} key={tab.key}>
      {tab.value}
    </Tabs.Tab>
  ));

  return (
    <Card shadow="sm" padding="lg" mb="lg" radius="md" withBorder>
      <Container fluid={true} className={classes.mainSection}>
        <Group position="apart">
          <Title order={4}>Region: {region.name}</Title>

          <Menu
            width={260}
            position="bottom-end"
            transitionProps={{transition: "pop-top-right"}}
            withinPortal
          >
            <Menu.Target>
              <UnstyledButton>
                <Group spacing={7}>
                  <Text weight={500} size="sm" sx={{lineHeight: 1}} mr={3}>
                    {t("common.action.plural", "Actions")}
                  </Text>
                  <IconChevronDown size={rem(12)} stroke={1.5}/>
                </Group>
              </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
              <RegionActionMenuDropdown region={region} onActionClick={onActionClick}/>
            </Menu.Dropdown>
          </Menu>

        </Group>
      </Container>

      <Card.Section>
        <Container fluid={true}>
          <Tabs
            defaultValue={state?.tabValue ?? "details"}
            onTabChange={(value) => navigate(`?id=${region.id}`, {state: {tabValue: value}})}
          >
            <Tabs.List>{items}</Tabs.List>
            <Space h="md"/>
            <Tabs.Panel value="details">
              <RegionDetails region={region}/>
            </Tabs.Panel>
          </Tabs>
        </Container>
      </Card.Section>
    </Card>
  );
};
